import { render } from "./UUtemplate.vue?vue&type=template&id=1434f716&scoped=true"
import script from "./UUtemplate.vue?vue&type=script&lang=js"
export * from "./UUtemplate.vue?vue&type=script&lang=js"

import "./UUtemplate.vue?vue&type=style&index=0&id=1434f716&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1434f716"

export default script